import React, { Component } from 'react';
import { Grid, Row, Col, Table, Popover, OverlayTrigger, Panel, PanelGroup } from "react-bootstrap";
import Select from 'react-select';
import { toast } from 'react-toastify';
import CustomModal from "../../components/Modal/CustomModal";

import { ConsultCarreras, ConsultaSemestres, Guardar, verSemestre, Delete, Editar } from '../../funciones/ModalidadesFunction';


let statusBtn = 0;
let idSemestre = null;

class Modalidades extends Component {
    state = {
        textInfo: <React.Fragment>Para agregar un nuevo semestre indica primero la <strong>Carrera</strong> a tu izquierda</React.Fragment>,
        valorCarrera: { value: '', label: '- Selecciona una Carrera -' },
        carreras: [{ value: '', label: ' - Cargando Espere - ' }],
        preloader:{ icon: "", text: "" },
        semestresDisp: [{ id: "", nombre: "" }],
        preloaderSem:{ icon: "", text: "" },
        btnDown: true,
        iconChevron: "fa fa-chevron-down",
        nombre:  { text:"", status: "" },
        num:  { text:"", status: "" },
        cantErrores: "",
        boton1: { Icon:"fa fa-save", Title:"Guardar" },
        boton2: { Icon:"fa fa-times", Title:"" },
        boton3: { Icon:"fa fa-edit", Title:"" },
        boton4: { Icon:"fa fa-trash", Title:"" },
        pensum: [],
        openDelSem: false,
    }

    constructor (props) {
        super (props);
        statusBtn = 0;
        ConsultCarreras ((resp) => {
            this.setState({carreras: resp})
        })
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]:{
                text:(event.target.value).toUpperCase(),
                status: "",
            },
            openDelSem: false,
        });
    };

    valorSelectCarrera = (valorCarrera) => {
        this.setState({
            valorCarrera,
            preloader:{
                icon: "fa fa-spinner fa-spin",
                text: "Cargando"
            },
            textInfo: <React.Fragment>Haz seleccionado <strong>{valorCarrera.label}</strong></React.Fragment>,
            openDelSem: false,
        },() => {
            ConsultaSemestres(valorCarrera.value, (resp) => {/* console.log(resp[1]) */
                this.setState({
                    semestresDisp: resp[0],
                    pensum: resp[1],
                    preloader:{ icon: "", text: "" },
                })
            })
        });
    }

    openWDelSem = () => {
        this.setState ({ openDelSem: true })
    }

    delSemestre = () => {
        let { nombre, valorCarrera } = this.state;
        let contenidoModal = <div>
            ¿Desea realmente <strong>eliminar el Periodo <span className="text-info">{nombre.text}</span></strong> del Sistema?
            <div style={{fontSize:9}}>ESta opción no puede deshacerse y puede ocasionar fallas al sistema</div>
            </div>

        return (
            <CustomModal
                isopen =  {this.state.openDelSem}
                titulo = {<div className="text-primary">Confirmación</div>}
                contenido = {contenidoModal}
                boton1 = "Si"
                boton2 = "No"
                funcion1 = { () => { Delete(idSemestre, () => {
                    if (valorCarrera.value !== "") ConsultaSemestres(valorCarrera.value, (resp) => {
                        this.setState({
                            semestresDisp: resp[0],
                            pensum: resp[1],
                            preloader:{ icon: "", text: "" },
                        })
                    })
                    toast.info("El Semestre fue eliminado exisosamente",{autoClose: 4000});
                    this.cancelar()
                })}}/>
        );
    }

    editSemestre = (id) => (e) => {
        idSemestre = id;
        statusBtn = 1;

        this.setState ({
            preloaderSem:{ icon: "fa fa-spinner fa-spin", text: "" },
            boton2: { Icon:"fa fa-times", Title:"", disabled: "disabled"},
            boton3: { Icon:"fa fa-edit", Title:"", disabled: "disabled"},
            boton4: { Icon:"fa fa-trash", Title:"", disabled: "disabled"},
            openDelSem: false,
        }, () => {
            verSemestre (id, (resp) => {
                this.setState(resp)
            })
        })
    } 

    semestresDisp = () => {
        let { semestresDisp } = this.state;

        if (semestresDisp[0] === undefined) return (
            <div style={{fontSize:12, paddingTop:15}} align="center">
                No existen semestres disponibles para esta carrera
            </div> 
        )

        if (semestresDisp[0].id === "") return (
            <div style={{fontSize:12, paddingTop:15}} align="center">
                Primero selecciona una <strong>Carrera</strong> para mostrar los semestres disponibles
            </div> 
        )

        let contenidoSemestres = () => {
            return(
                semestresDisp.map(option => (
                    <tr onClick = {this.editSemestre (option.id)} key={option.id} style={{cursor: "pointer"}} title = {`Haz Click para editar ${option.nombre}`}>
                        <td>{option.nombre}</td>
                    </tr>
                ))
            )
        }

        return (
            <div className="table-responsive" style={{backgroundColor:"#FFF"}}>
                <Table striped hover>
                    <tbody>
                        {contenidoSemestres()}
                    </tbody>
                </Table>
            </div>
        );
    }

    modalidades = () => {
        let { valorCarrera, carreras, preloader } = this.state;

        return (
            <div className="custom-alert-info" style={{padding: 10}}>
                <Select
                    isSearchable ={true}
                    value={valorCarrera}
                    onChange={this.valorSelectCarrera}
                    options={carreras}
                />
                <div align="center" style={{marginTop:5}}><i className={preloader.icon}></i>{preloader.text}</div>
                <div style={{ overflowY :"auto", height:"45vh",}}>{this.semestresDisp()}</div>
            </div>
        )
    }

    cambiaIcon = () => {
        this.setState ({
            btnDown: !this.state.btnDown,
            openDelSem: false,
        }, () => {
            (this.state.btnDown === true) ? this.setState({iconChevron: "fa fa-chevron-down"}) : this.setState({iconChevron: "fa fa-chevron-up"})
        })
    }

    pensumContent = () => {
        let { pensum } = this.state;

        if (pensum.length === 0) {
            return(
                <div align="center" style={{paddingBottom: 10}}>
                    Esta carrera no posee materias registradas
                </div>
            )
        }

        let matValida = (select, sem) => {

            let contenido = [];

            if (select.semestre === sem) {
                contenido.push (
                    <tr key={select.id}>
                        <td style={{fontSize:8, paddingTop:0, paddingBottom:0}} height={30} align="center">{select.codigo}</td>
                        <td style={{fontSize:10, paddingTop:0, paddingBottom:0}} height={30} align="left">{select.nombre}</td>
                        <td style={{fontSize:8, paddingTop:0, paddingBottom:0}} height={30} align="center">{select.prelacion1}</td>
                        <td style={{fontSize:8, paddingTop:0, paddingBottom:0}} height={30} align="center">{select.prelacion2}</td>
                        <td style={{fontSize:10, paddingTop:0, paddingBottom:0}} height={30} align="center">{select.horas}</td>
                        <td style={{fontSize:10, paddingTop:0, paddingBottom:0}} height={30} align="center">{select.uc}</td>
                    </tr>
                )
            }

            return contenido;
        }

        let materias = (sem) => {
            return (
                pensum.map(option => (
                    <React.Fragment key={option.id}>
                        {matValida(option, sem)}
                    </React.Fragment>
                ))
            )
        }

        let horas = (sem) => {
            let horas= 0;
            for (let i in pensum) {
                if (pensum[i].semestre === sem) horas += parseInt(pensum[i].horas);
            }
            return horas;
        }

        let uc = (sem) => {
            let uc= 0;
            for (let i in pensum) {
                if (pensum[i].semestre === sem) uc += parseInt(pensum[i].uc);
            }
            return uc;
        }

        let semestre = (sem) => {
            return (
                <div className="table-responsive" style={{backgroundColor:"#FFF"}}>
                    
                    <Table striped hover bordered>
                        <tbody>
                            <tr className="custom-background-color">
                                <td align="center" colSpan={6} style={{paddingTop:0, paddingBottom:0}}><strong>{`SEMESTRE ${sem}`}</strong></td>
                            </tr>
                            <tr className="custom-background-color">
                                <td style={{fontSize:10}} width="10%" align="center"><strong>CÓDIGO</strong></td>
                                <td style={{fontSize:10}} width="70%" align="center"><strong>UNIDAD CURRICULAR</strong></td>
                                <td style={{fontSize:10}} width="20%" colSpan={2} align="center"><strong>PRELACIONES</strong></td>
                                <td style={{fontSize:10}} width={60} align="center"><strong>HORAS</strong></td>
                                <td style={{fontSize:10}} width={60} align="center"><strong>U.C.</strong></td>
                            </tr>
                            {materias(sem)}
                            <tr className="custom-background-color">
                                <td colSpan={4} style={{paddingTop:0, paddingBottom:0}} align="right"><strong>TOTAL SEMESTRE</strong></td>
                                <td style={{fontSize:10, paddingTop:0, paddingBottom:0}} width={60} align="center"><strong>{horas(sem)}</strong></td>
                                <td style={{fontSize:10, paddingTop:0, paddingBottom:0}} width={60} align="center"><strong>{uc(sem)}</strong></td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            )
        }

        return (
            <div /* style={{ overflowY :"auto", height:"45vh",}} */>
                <div>{semestre(1)}</div>
                <div className="custom-mt-10">{semestre(2)}</div>
                <div className="custom-mt-10">{semestre(3)}</div>
                <div className="custom-mt-10">{semestre(4)}</div>
                <div className="custom-mt-10">{semestre(5)}</div>
                <div className="custom-mt-10">{semestre(6)}</div>
            </div>
        );
    }

    pensum = () => {
        let { valorCarrera, iconChevron } = this.state;
        if (valorCarrera.value === "") return null;

        return (
            <PanelGroup
                accordion
                activeKey={this.state.activeKey}
                /* onSelect={this.cambiaPanel} */
                className="custom-alert-info"
                id="materias"
            >
                <Panel eventKey={1}>
                    <Panel.Heading>
                        <Panel.Title toggle style={{color:"#1f2f6e"}} onClick={this.cambiaIcon}>
                            <Row>
                                <Col md={10}>
                                    Ver Plan de Estudio
                                </Col>
                                <Col md={2} align="right">
                                    <i className={iconChevron}></i>
                                </Col>
                            </Row>
                        </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body collapsible style={{padding:0, paddingTop:10}}>
                        {this.pensumContent()}
                    </Panel.Body>
                </Panel>
            </PanelGroup>
        )
    }

    cancelar = () => {
        statusBtn = 0;

        this.setState ({
            cantErrores: "",
            boton1: { Icon:"fa fa-save", Title:"Guardar" },
            boton2: { Icon:"fa fa-times", Title:"" },
            boton3: { Icon:"fa fa-edit", Title:"" },
            boton4: { Icon:"fa fa-trash", Title:"" },
            nombre:  { text:"", status: "" },
            num:  { text:"", status: "" },
            openDelSem: false,
        })
    }
    
    respuestaGuardar = (resp) => {
        let mensaje = resp[1];
        let errores = resp[2];
        let nameErrores = resp[3]
        let contentErr = [];

        let erroresList = (
            <Popover bsSize="large" title="Errores Encontrados" id="erroresList">
                {contentErr}
            </Popover>
        )

        let messOk = (mensaje) => {
            let { valorCarrera } = this.state;
            
            if (valorCarrera.value !== "") ConsultaSemestres(valorCarrera.value, (resp) => {
                this.setState({
                    semestresDisp: resp[0],
                    pensum: resp[1],
                    preloader:{ icon: "", text: "" },
                })
            })
            
            this.setState({
                boton1:{
                    Icon:"fa fa-save",
                    Title:"Guardar",
                }
            }, () => {
                if (mensaje.status !== "error") {
                    this.setState({
                        nombre:  { text:"", status: "" },
                        num:  { text:"", status: "" },
                    })
                }

                toast[mensaje.status](mensaje.mensaje,{autoClose: 4000});
            })
        }

        for (let i in nameErrores) {
            if (nameErrores[i] !== "") contentErr.push(
                <div key = {i} className="text-danger" style={{fontSize:10, marginBottom:8}}><i className="fa fa-exclamation-triangle"></i> {nameErrores[i]}</div>
            )
        }

        if (errores === 0) {
            this.setState({ cantErrores:"" })
        }

        if (mensaje[0].status === "error" && errores !== 0) this.setState ({
            openDelSem: false,
            cantErrores: <div style={{paddingTop:10}}>
                            Se han encontrado {errores} error(es). Haz click <span>
                            <OverlayTrigger trigger="focus" placement="top" overlay={erroresList}>
                                <button style={{borderWidth: 1}} className="btn btn-danger btn-xs">Aqui</button> 
                            </OverlayTrigger></span> para verlos
                        </div>
        })

        messOk(mensaje[0]);
    }

    respuestaEditar = (resp) => {
        let mensaje = resp[1];
        let errores = resp[2];
        let nameErrores = resp[3]
        let contentErr = [];

        let erroresList = (
            <Popover bsSize="large" title="Errores Encontrados" id="erroresList">
                {contentErr}
            </Popover>
        )

        let messOk = (mensaje) => {
            let { valorCarrera } = this.state;
            
            if (valorCarrera.value !== "") ConsultaSemestres(valorCarrera.value, (resp) => {
                this.setState({
                    semestresDisp: resp[0],
                    pensum: resp[1],
                    preloader:{ icon: "", text: "" },
                })
            })
            
            this.setState({
                boton3:{ Icon:"fa fa-edit" }
            }, () => {
                if (mensaje.status !== "error") {
                    this.setState({
                        nombre:  { text:"", status: "" },
                        num:  { text:"", status: "" },
                    })
                }

                toast[mensaje.status](mensaje.mensaje,{autoClose: 4000});
            })
        }

        for (let i in nameErrores) {
            if (nameErrores[i] !== "") contentErr.push(
                <div key = {i} className="text-danger" style={{fontSize:10, marginBottom:8}}><i className="fa fa-exclamation-triangle"></i> {nameErrores[i]}</div>
            )
        }

        if (errores === 0) this.setState({ cantErrores:"" })
        if (mensaje[0].status === "error" && errores !== 0) this.setState ({
            cantErrores: <div style={{paddingTop:10}}>
                            Se han encontrado {errores} error(es). Haz click <span>
                            <OverlayTrigger trigger="focus" placement="top" overlay={erroresList}>
                                <button style={{borderWidth: 1}} className="btn btn-danger btn-xs">Aqui</button> 
                            </OverlayTrigger></span> para verlos
                        </div>
        })

        messOk(mensaje[0]);
    }

    botones = () => {
        let { boton1,boton2, boton3, boton4, nombre, num, valorCarrera } = this.state;
        const campos = { nombre, num, valorCarrera }
        switch (statusBtn) {
            case 0:
                return (
                    <button className="btn btn-primary" disabled={boton1.disabled} style={{borderWidth: 1}} onClick={ (e) => {
                        this.setState({
                            openDelSem: false,
                            boton1:{ Icon: "fa fa-spinner fa-spin", Title: "Cargando" }
                        }, () => {
                            Guardar (campos, (resp) => { this.respuestaGuardar(resp) })
                        })
                    }}><i className={boton1.Icon}></i> {boton1.Title}</button>
                )
            case 1:
                return (
                    <div className="btn-group" role="group">
                        <button className="btn btn-primary"  disabled={boton2.disabled} onClick ={this.cancelar} title="Cancelar" style={{borderWidth: 1}}><i className={boton2.Icon}></i></button>
                        <button className="btn btn-warning"  disabled={boton3.disabled}
                        onClick={ (e) => {
                            this.setState({
                                boton3:{ Icon: "fa fa-spinner fa-spin" },
                                openDelMat: false
                            }, () => {
                                Editar (idSemestre, campos, (resp) => { this.respuestaEditar(resp) })
                            })
                        }}
                        title="Editar este Semestre" style={{borderWidth: 1}}><i className={boton3.Icon}></i></button>
                        <button className="btn btn-danger" disabled={boton4.disabled} onClick={this.openWDelSem} title="Eliminar este Semestre" style={{borderWidth: 1}}><i className={boton4.Icon}></i></button>
                    </div>
                )
            default:
                return (<div></div>)
        }
    }

    registro = () => {
        let  { preloaderSem, textInfo, nombre, num, cantErrores } = this.state;

        let MainAyuda = (
            <Popover title="Registro de Modalidaes" id="mod">
                <div align="justify">
                    Mediante esa opción podrás registrar los semestres para cada carrera. Para ello primero debes seleccionar una carrera de tu izquierda.
                </div>
                <div align="justify" className="custom-mt-10">
                    Luego de seleccionar la carrera podrás agregar un nuevo semestre llenando los campos correspondientes y presionando el botón <button className="btn btn-primary btn-xs" style={{borderWidth:1}}><i className="fa fa-save"></i> Guardar</button>
                </div>
                <div align="justify" className="custom-mt-10">
                    Al seleccionar una carrera podrás ver el Plan de Estudio de dicha carrera haciendo click en la opción
                    <div className="custom-alert-info custom-color" align="center">Ver Plan de Estudio <i className="fa fa-chevron-down"></i></div>
                </div>
                
                <div align="justify" className="custom-mt-10">
                    Para modificar semestres primero haz click en uno de los agregados a tu izquierda
                </div>
                <div align="justify" style={{fontSize:10}} className="custom-mt-10">
                    El botón <button className="btn btn-primary btn-xs" style={{borderWidth:1}}><i className="fa fa-times"></i></button> Permite cancelar la selección
                </div>
                <div align="justify" style={{fontSize:10, marginTop: 5}}>
                    El botón <button className="btn btn-warning btn-xs" style={{borderWidth:1}}><i className="fa fa-edit"></i></button> Permite guardar los cambios
                </div>
                <div align="justify" style={{fontSize:10, marginTop: 5}}>
                    El botón <button className="btn btn-danger btn-xs" style={{borderWidth:1}}><i className="fa fa-trash"></i></button> Permite eliminar el pais seleccionado
                </div>
            </Popover>
        )

        return (
            <React.Fragment>
                <div className="custom-alert-success">
                    <Row>
                        <Col md={9} style={{paddingTop: 8, paddingLeft: 25}}>
                        <span><i className={preloaderSem.icon}></i>{preloaderSem.text}</span> {textInfo}
                        </Col>
                        <Col md={3} align="right">
                            <OverlayTrigger trigger="focus" placement="left" overlay={ MainAyuda }>
                                <button className="btn btn-relleno-success" style={{borderWidth:1}} title="Ayuda"><i className="fa fa-question-circle-o"></i></button>
                            </OverlayTrigger>
                        </Col>
                    </Row>
                </div>
                
                <Row>
                    <Col md ={5}><div className="custom-mt-20"><a style={{color:"#1f2f6e"}}>Registrar un Nuevo Semestre</a></div></Col>
                    <Col md ={7}><div className="text-danger" style={{marginTop: 8}}>{ cantErrores }</div></Col>
                </Row>
                <Row className="custom-mt-10">
                    <Col md={4}>
                        <div className={nombre.status}>
                            <input type="text" value={nombre.text} onChange={this.cambiaValor("nombre")} className="form-control" maxLength={100} title="Nombre del Semestre o Periodo" placeholder="* Nombre del Semestre o Periodo"/>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className={num.status}>
                            <input type="text" value={num.text} onChange={this.cambiaValor("num")} className="form-control" maxLength={2} title="Número del Semestre o Periodo" placeholder="* Número del Semestre o Periodo"/>
                        </div>
                    </Col>
                    <Col md={4} align="right">
                        {this.botones()}
                    </Col>
                </Row>
                {this.pensum()}
            </React.Fragment>
        )
    }

    render() { 
        return (
            <Grid fluid >
                <Row>
                    <Col md={4}>{this.modalidades()}</Col>
                    <Col md={8}>{this.registro()}</Col>
                </Row>
                {this.delSemestre()}
            </Grid>    
        );
    }
}
 
export default Modalidades;


// WEBPACK FOOTER //
// ./src/views/Registros/Modalidades.jsx